import React from 'react';
import { Link } from 'react-router-dom';
import './product-star-review.scss';

export class ProductReviewStars extends React.Component {
  generateReviewSnippet(reviewStars, reviewCount, isMobile) {
    var goToReviewSection = function () {
      if (!isMobile) {
        var headerOffset = 115;
        $('html, body').animate(
          {
            scrollTop: $('.review-detail-section').offset().top - headerOffset,
          },
          500
        );
      } else {
        var headerMobileOffset = 15;
        $('html, body').animate(
          {
            scrollTop: $('.product-review-wrapper').offset().top - headerMobileOffset,
          },
          500
        );
        $('.product-review-wrapper .panel-icon').addClass('expanded');
        $('.product-review-wrapper .product-reviews').removeClass('hidden');
      }
    };
    var numOfStars = reviewStars;
    var returnElements = [];
    if (numOfStars > 0) {
      for (var iStar = 0; iStar <= 4; iStar++) {
        if (Math.floor(numOfStars) > iStar) {
          returnElements.push(
            <i key={iStar} className='icon star-full'>
              <span className='sr-only'>{`Rated ${numOfStars} out of 5 stars`}</span>
            </i>
          );
        } else if (numOfStars > iStar) {
          returnElements.push(
            <i key={iStar} className='icon star-half'>
              <span className='sr-only'>{`Rated ${numOfStars} out of 5 stars`}</span>
            </i>
          );
        } else {
          returnElements.push(
            <i key={iStar} className='icon star-empty'>
              <span className='sr-only'>{`Rated ${numOfStars} out of 5 stars`}</span>
            </i>
          );
        }
      }
      returnElements.push(
        <span
          className={`reviewCount ${!isMobile ? 'btn btn-tertiary p-0' : ''}`}
          key={++iStar}
          onClick={goToReviewSection}
        >
          {reviewCount} Review{reviewCount > 1 ? 's' : ''}
        </span>
      );
    }
    return returnElements;
  }
  render() {
    var reviewCount = this.props.contentData.reviewCount;
    var reviewStars = this.props.contentData.reviewStars;
    if (this.props.passedFunctions.parentState.liveReviewCount) {
      reviewCount = this.props.passedFunctions.parentState.liveReviewCount;
    }
    if (this.props.passedFunctions.parentState.liveReviewStars) {
      reviewStars = this.props.passedFunctions.parentState.liveReviewStars;
    }
    reviewCount = (reviewCount || 0) * 1;
    reviewStars = (reviewStars || 0) * 1;

    return (
      <div className='reviewHeader'>
        {this.props.contentData.reviews && reviewCount === 0 && (
          <div key='asdf' className={`${this.props.contentData.unavailableMessage ? 'beTheFirst' : 'beTheFirst'}`}>
            <svg xmlns='http://www.w3.org/2000/svg' height='11' width='11' viewBox='0 0 50.77 48.69' aria-hidden='true'>
              <defs />
              <g data-name='Layer 2'>
                <path
                  className='cls-1'
                  d='M50.75,19a.49.49,0,0,0-.47-.34H32L25.85.33a.49.49,0,0,0-.93,0L18.81,18.67H.49a.49.49,0,0,0-.28.89L15.27,30.14,9.57,48.06a.49.49,0,0,0,.75.54l15.06-11,15.06,11a.49.49,0,0,0,.75-.54L35.5,30.14,50.56,19.56A.49.49,0,0,0,50.75,19Z'
                  data-name='Layer 1'
                />
              </g>
            </svg>
            Be the first to
          </div>
        )}

        <div id='pr-reviewsnippet'>
          {reviewCount === 0 ? (
            <Link
              className={`pr-snippet-write-review-link ${this.props.passedAppFunctions.siteFormat !== 'mobile' ? 'btn btn-tertiary p-0' : ''}`}
              to={
                this.props.contentData.reviews.reviewURL === undefined
                  ? this.props.contentData.reviews.reviewURL
                  : this.props.contentData.reviews.reviewURL.indexOf('pr_headline') !== -1
                    ? this.props.contentData.reviews.reviewURL
                    : this.props.contentData.reviews.reviewURL + '&pr_headline=Product%20Review'
              }
            >
              Write A Review
            </Link>
          ) : (
            <>
              {this.generateReviewSnippet(
                reviewStars,
                reviewCount,
                this.props.passedAppFunctions.siteFormat === 'mobile'
              )}
              {<span className='sr-only'>{`Rated ${reviewStars} out of 5 stars`}</span>}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default ProductReviewStars;
